import { render, staticRenderFns } from "./close-dialog.vue?vue&type=template&id=0daa10e8&scoped=true&"
import script from "./close-dialog.vue?vue&type=script&lang=js&"
export * from "./close-dialog.vue?vue&type=script&lang=js&"
import style0 from "./close-dialog.vue?vue&type=style&index=0&id=0daa10e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daa10e8",
  null
  
)

export default component.exports